import { render } from "./EditSubcategoryView.vue?vue&type=template&id=0d8e4cdb&scoped=true"
import script from "./EditSubcategoryView.vue?vue&type=script&lang=js"
export * from "./EditSubcategoryView.vue?vue&type=script&lang=js"

import "./EditSubcategoryView.vue?vue&type=style&index=0&id=0d8e4cdb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8e4cdb"]])

export default __exports__